import type { MembershipSource as MembershipSourceValue } from '@/graphql';

/** How the active membership came about — mirrors the schema's `MembershipSource`. */
export const MembershipSource = {
  /** Invited directly into the account. */
  DIRECT: 'DIRECT',
  /** Materialized from a master account role or assignment. */
  MASTER_ACCOUNT: 'MASTER_ACCOUNT'
} as const satisfies { [K in MembershipSourceValue]: K };
